import React, { useEffect, useState } from 'react'
import { useBreadcrumbs } from '../../../context/BreadcrumbsContext'
import useFetchData from '../../../hooks/useFetchData'
import useBreadcrumbMapping from '../../../hooks/useBreadcrumbMapping'
import { useNavigate, useOutletContext, useParams, useLocation } from 'react-router-dom'
import { ArrowLeftIcon, ChevronDownIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline'

import CreateCapsule from '../CreateCapsule/CreateCapsule'
import UpdateCapsule from '../UpdateCapsule/UpdateCapsule'
import LoadingSpinner from '../../Common/Loading/LoadingSpinner'

const CapsuleDisplay = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { capsuleId } = useParams()
    const [capsule, setCapsule] = useState(null)
    const outletContext = useOutletContext()
    const [shouldFetch, setShouldFetch] = useState(!outletContext || !outletContext.capsules)
    const { data: fetchedCapsule, error, isLoading } = useFetchData(
        shouldFetch ? `/capsules/${capsuleId}` : null
    )

    // Utiliser le hook pour enregistrer automatiquement le mapping capsule
    useBreadcrumbMapping(
        capsuleId,
        capsule?.name,
        'capsule',
        !!capsule
    );

    // Déterminer la version par défaut selon l'action (modifier vs valider)
    const getDefaultVersion = (configurations) => {
        if (!configurations || configurations.length === 0) return 0;

        // Si on vient de "Valider" (createNewConfig = true), on sélectionne la dernière version
        // Sinon (modifier), on sélectionne la première version
        const isValidationMode = location.state?.createNewConfig === true;
        return isValidationMode ? configurations.length - 1 : 0;
    };

    const defaultVersion = shouldFetch
        ? getDefaultVersion(fetchedCapsule?.configurations)
        : getDefaultVersion(outletContext.capsules.find(capsule => capsule.id === Number(capsuleId))?.configurations)

    const [selectedVersion, setSelectedVersion] = useState(defaultVersion);

    useEffect(() => {
        if (outletContext && outletContext.capsules) {
            const currentCapsule = outletContext.capsules.find(capsule => capsule.id === Number(capsuleId))
            if (currentCapsule) {
                setCapsule(currentCapsule)
                setShouldFetch(false)  // Don't fetch if data is found in outlet context
            }
        } else if (fetchedCapsule) {
            setCapsule(fetchedCapsule)
        }
    }, [outletContext, fetchedCapsule, capsuleId])

    useEffect(() => {
        if (!capsule && !isLoading) {
            navigate('../')
        }
    }, [capsule, isLoading])

    if (isLoading) return <LoadingSpinner />
    if (error) return <div>Error loading capsule data</div>
    return (
        <div className='mt-4'>

            {capsule && capsule.configurations.length >= 1 && (
                <>
                    <div className="flex flex-col gap-4">
                        <UpdateCapsule
                            capsule={capsule}
                            selectedConfigurationId={capsule.configurations[selectedVersion].id}
                            configuration={capsule.configurations[selectedVersion].configuration}
                            selectedVersion={selectedVersion}
                            setSelectedVersion={setSelectedVersion}
                        />
                    </div>
                </>
            )}
            {capsule && capsule.configurations.length < 1 && (
                <CreateCapsule capsule={capsule} />
            )}
        </div>
    )
}

export default CapsuleDisplay
